import { flow, getEnv, Instance, types } from "mobx-state-tree";
import { endpoints } from "../api/ApiEndpoints";

export const VideoConversionModel = types.model({
    fileId: types.frozen<number | undefined>(),
    isConverted: types.optional(types.boolean, false),
    sas: types.optional(types.string, ""),
    isLoading: types.optional(types.boolean, false),
    conversionWasSuccessful: types.optional(types.boolean, false),
    name: types.optional(types.string, "")
}).views((self) => ({

})).actions((self) => {
    const loadConversion = flow(function* () {
        self.isLoading = true;
        const endpoint = endpoints.get("media_file_video_conversion");
        endpoint.routeParams = [self.fileId!];

        const response = yield getEnv(self).api.get(endpoint);
        self.sas = response.sas;
        self.isConverted = response.isConverted;
        self.conversionWasSuccessful = response.conversionWasSuccessful;
        self.name = response.name;

        self.isLoading = false;
    });

    return {
        afterCreate() {
            if (self.fileId === undefined) return;
            loadConversion();
        },
        reload() {
            loadConversion();
        },
        copySas() {
            if (self.sas === "") return;
            navigator.clipboard.writeText(self.sas);
        },
        setFileId(id: number) {
            self.fileId = id;
        }
    }
})

export type VideoConversionService = Instance<typeof VideoConversionModel>;